import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class AssetCustomField extends Base {
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  list(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/cmms/asset-custom-field?" + queryParam);
    return this._secureFetch(url);
  }
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */

  create(payload) {
    const url = this._getFullURL("/cmms/asset-custom-field");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  update(id, payload) {
    const url = this._getFullURL("/cmms/asset-custom-field/" + id);
    return fetch(url, this._generateRequestBody({ payload, method: "PUT" }));
    
  }

  delete = (id) => {
    const url = this._getFullURL(`/cmms/asset-custom-field/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      })
    );
  };
}
